import React, {useEffect} from 'react';
import Skeleton from 'react-loading-skeleton';
import { faArrowDown as falArrowDown } from '@fortawesome/pro-light-svg-icons';
import { faArrowDown as fatArrowDown } from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';

import Checkers from '../../../helpers/class/Checkers';
import BottomSections from '../../BottomSections';
import Header from '../../Header';
import Jumbotron from '../../Jumbotron';
import FeaturedImages from '../../jumbotron/FeaturedImages';
import ReadMoreText from '../../ReadMoreText';
import ViewPort from '../../ViewPort';

import ArticleTypes from './ArticleTypes';
import ArticleCategoriesContainer from "./ArticleCategoriesContainer";

export default function Sections ( props ) {
    const referer = props.referer;
    const app_data = props.app_data;
    const app = props.app;
    const head = props.head;
    const navigation = props.navigation;
    const locations = props.locations;
    const footer = props.footer;
    const contactIcons = props.contactIcons;

    const isDesktop = props.isDesktop;

    return (
        <>
            {/*<Header*/}
            {/*    app={app}*/}
            {/*    builder={props.builder}*/}
            {/*    phone={head.location[0].phone}*/}
            {/*    menu={navigation.menu}*/}
            {/*    partials={navigation.partials}*/}
            {/*    showBookButtonMenu={app.showBookButtonMenu}*/}
            {/*    contactIcons={app.showContactIconsOnMenu ? contactIcons : null}*/}
            {/*    pageTitle={head.data.title}*/}
            {/*    property={true}*/}
            {/*    referer={referer}*/}
            {/*/>*/}
            {/*<div id="articles_top"/>*/}
            {
                props.content.hasOwnProperty('htmlCode') && Checkers.isValidString(props.content.htmlCode) ?
                    <>
                        <div dangerouslySetInnerHTML={{__html: props.content.htmlCode}}/>
                    </>
                    :
                    <>
                        <ArticleCategoriesContainer
                            app_data={props.app_data}
                            app={props.app}
                            builder={props.builder}
                            type={props.type}
                            content={props.content}
                            isDesktop={isDesktop}
                            articlesCategories={props.articlesCategories}
                            includeJumbotron={true}
                            itemClassName={'experience-design-box'}
                        />
                    </>
            }
            {/*<BottomSections*/}
            {/*    isDesktop={isDesktop}*/}
            {/*    contactSection={app.showContactSection}*/}
            {/*    footerSection={true}*/}
            {/*    app_data={app_data}*/}
            {/*    app={app}*/}
            {/*    head={head}*/}
            {/*    locations={locations}*/}
            {/*    footer={footer}*/}
            {/*    htmlSections={props.htmlSections}*/}
            {/*/>*/}
        </>
    )
}
